import React from "react";

import { Box, Typography } from "@mui/material";
import format from "date-fns/format";

type EndDateProps = {
  endDate: string | undefined;
};

const EndDate: React.FC<EndDateProps> = ({ endDate }) => {
  const formattedStartDate = format(
    new Date(endDate != undefined ? endDate : new Date()),
    "dd MMM, yyyy"
  );
  return (
    <Box
      marginLeft={{ xs: 0, md: 3 }}
      marginRight={3}
      display="flex"
      flexDirection="row"
      alignItems="center"
    >
      <Typography variant="body1" color="textSecondary">
        End date:
      </Typography>
      <Typography variant="body1" color="textPrimary">
        {formattedStartDate}
      </Typography>
    </Box>
  );
};

export default EndDate;
